import { optionalStringParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

export const loginSearchSchema = parseableSearchSchema(
  Schema.Struct({
    error: optionalStringParam(),
    "auto-login-as": Schema.optional(
      Schema.String.pipe(Schema.check(Schema.isPattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))),
    ),
  }),
);

export type LoginSearch = Schema.Schema.Type<typeof loginSearchSchema>;
